import React from 'react';
import { Grid, Typography } from '@mui/material';
import { CheckCircle, Close } from '@mui/icons-material';

export type PasswordValidationItem = {
  label: string;
  validation: (password: string) => boolean;
};

type CheckLineProps = {
  item: PasswordValidationItem;
  password: string;
};

const CheckLine: React.FC<CheckLineProps> = ({ item, password }) => {
  return (
    <Grid container spacing={2} alignItems={'center'}>
      <Grid item xs={2}>
        {item.validation(password) ? <CheckCircle color={'success'} /> : <Close color={'error'} />}
      </Grid>
      <Grid item xs={10}>
        <Typography variant={'body1'}>{item.label}</Typography>
      </Grid>
    </Grid>
  );
};

export default CheckLine;
